import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";

//redux
import { withRouter, Link, useHistory } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import Logo from "../../assets/images/logo-large.png";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';


const ForgetPasswordPage = props => {
  //meta title
  document.title = "Forgot Password";
  const history = useHistory();
  const { getRequestWOAccessToken, postRequestWOAccessToken } = useRequestsWOAccessToken();


  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Please enter a valid value!')
        .max(255)
        .required('Email is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          email: values.email
        });
        const res = await postRequestWOAccessToken('forgot-password', jsonpar);
        if (res && res.code === 200) {
          let originalText = res.data;

          history.push('/change-password', { id: originalText, email: values.email, code: 200, status: 'success', message: res.message });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Submit';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="account-pages">
        <Container className="full-page">
          <Row className="centerBox">
            <Col className="login-box">
              <Card className="overflow-hidden">
                <CardBody>
                  <Link to="/login" className="logo center-logo"><span className="text-center"><img src={Logo} alt="" /></span></Link>
                  <h3 className="text-center mt-3 mb-3 title-fonts">Forgot your password ?</h3>
                  <div className="p-2">
                    <Form>
                      <div className="mb-3">
                        <Label className="form-label">Email :</Label>
                        <Input
                          name="email"
                          type="email"
                          placeholder={'Enter email'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.email || ""}
                          invalid={
                            validation1.touched.email && validation1.errors.email ? true : false
                          }
                        />
                        {validation1.touched.email && validation1.errors.email ? (
                          <FormFeedback type="invalid">{validation1.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-4 d-grid">
                        <button
                          id="submit1"
                          onClick={(e) => {
                            e.preventDefault();
                            validation1.handleSubmit();
                            return false;
                          }}
                          className="btn btn-primary btn-block"> {'Submit'} </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="footer-text-color"> Go back to{" "} <Link to="/login" className="font-weight-medium text-underline"> Login </Link>
                </p>
                <p className="footer-text-color"> © {new Date().getFullYear()} Eshepay.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
